/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type AdminAccountsListRole = typeof AdminAccountsListRole[keyof typeof AdminAccountsListRole];


export const AdminAccountsListRole = {
  admin: 'admin',
  student: 'student',
  superadmin: 'superadmin',
  teacher: 'teacher',
} as const;
